import { utils, writeFile } from 'xlsx';
import { movementsExcelMapping } from './movements-excel-mapping';

export const generateMovementsTemplate = () => {
  // Create worksheet with headers
  const ws = utils.aoa_to_sheet([
    Object.keys(movementsExcelMapping)
  ]);

  // Add some example data
  const exampleData = [
    {
      'Temporada': '2024-2025',
      'Especie': '1',
      'Monto USD': '100',
      'Productor (debe coincidir con planilla de despachos)': 'JUAN PEREZ',
      'Grupo Productor (debe coincidir con planilla de despachos)': 'GRUPO PEREZ',
    }
  ];

  // Add example row
  utils.sheet_add_json(ws, exampleData, {
    origin: 'A2',
    skipHeader: true
  });

  // Create workbook
  const wb = utils.book_new();
  utils.book_append_sheet(wb, ws, 'Movimientos');

  // Generate file
  writeFile(wb, 'plantilla-movimientos.xlsx');
};